/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue } from './TimelineItem';

const TimelineItemManager: ComponentManagerFn<'TimelineItem'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'TimelineItem'>(platform, 'TimelineItem'),
    type: 'TimelineItem',
    name: 'Timeline Item',
    defaultChildren: ['TimelineSeparator', 'TimelineContent'],
    isChildAllowed: (page, item, childType, { appUid, pageId }) => {
      if (
        !(
          [
            'TriggerOnClick',
            'TimelineSeparator',
            'TimelineContent',
            'TimelineOppositeContent',
          ] as ItemType[]
        ).includes(childType)
      ) {
        return false;
      }
      const children = platform.getChildrenOfType(
        appUid,
        pageId,
        page,
        item,
        childType,
      );
      return children.length === 0 ? true : 'Already added';
    },

    onChildMoveIn: ({ page, value }) => {
      // Timeline Opposite content must be first child
      value.children = value.children.sort((a, b) => {
        const aItem = page[a];
        const bItem = page[b];
        if (aItem && bItem) {
          if (
            aItem.type === 'TimelineOppositeContent' ||
            bItem.type === 'TimelineContent'
          ) {
            return -1;
          }
          if (
            bItem.type === 'TimelineOppositeContent' ||
            aItem.type === 'TimelineContent'
          ) {
            return 1;
          }
        }
        return 0;
      });
    },
    defaultValue,
    props: {},
    getDisplayText: () => 'Timeline Item',
    category: 'Data',
    icon: { iconName: 'calendar' },
    description: 'A timeline item',
  };
};

export default TimelineItemManager;
